import React, { useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import {
  LayoutDashboard,
  Users,
  BarChart2,
  LogOut,
  Menu,
  X,
  Shield,
  ArrowRightLeft,
  Settings
} from "lucide-react";
import logo from '../asset/kestren.png';

export default function AdminNavbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const logout = () => {
    localStorage.removeItem("token");
    window.dispatchEvent(new Event("tokenChanged"));
    navigate("/admin/login");
  };


  const navItems = [
    { to: "/admin/dashboard", label: "Dashboard", icon: <LayoutDashboard className="w-5 h-5" /> },
    { to: "/admin/clients", label: "Clients", icon: <Users className="w-5 h-5" /> },
    { to: "/admin/stats", label: "Stats", icon: <BarChart2 className="w-5 h-5" /> },
    { to: "/admin/transections", label: "Transactions", icon: <ArrowRightLeft className="w-5 h-5" /> },
    { to: "/admin/setting", label: "Setting", icon: <Settings className="w-5 h-5" /> }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 sticky backdrop-blur-xl bg-black/95 border-b border-white/10 shadow-lg shadow-black/20 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">

        <div className="flex justify-between items-center h-16">

          {/* Logo */}
          <Link
            to="/admin/dashboard"
            className="flex items-center space-x-3 hover:scale-105 transition-transform duration-200"
          >
            <img
              src={logo}
              alt="Logo"
              className="w-10 h-10 object-contain"
            />

            <span className="text-xl font-bold tracking-widest text-white hidden sm:block">
              KESTREN ADMIN
            </span>
          </Link>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-1">
            {navItems.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className={`flex items-center space-x-2 px-4 py-2 rounded-xl text-gray-300 hover:text-white hover:bg-white/10 transition-all duration-200 relative group
                  ${isActive(item.to) ? "bg-white/10 text-white shadow-inner" : ""}
                `}
              >
                <span className="group-hover:scale-110 transition-transform">
                  {item.icon}
                </span>
                <span className="font-medium">{item.label}</span>

                {/* Active underline (desktop only) */}
                {isActive(item.to) && (
                  <span className="absolute bottom-0 left-1/2 -translate-x-1/2 w-10 h-[2px] bg-white rounded-full"></span>
                )}
              </Link>
            ))}

            <button
              onClick={logout}
              className="flex items-center space-x-2 ml-4 bg-red-600 hover:bg-red-700 px-4 py-2 rounded-xl transition-all duration-200 hover:shadow-lg hover:shadow-red-500/25"
            >
              <LogOut className="w-5 h-5" />
              <span>Logout</span>
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden p-2 rounded-lg hover:bg-white/10 transition"
          >
            {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden pb-4 animate-fadeIn">
            <div className="flex flex-col space-y-2">
              {navItems.map((item) => (
                <Link
                  key={item.to}
                  to={item.to}
                  onClick={() => setIsMobileMenuOpen(false)}
                  className={`flex items-center space-x-3 px-4 py-3 rounded-lg transition-all 
                    ${isActive(item.to) ? "bg-white/10 text-white font-semibold" : "text-gray-300 hover:bg-white/10"}
                  `}
                >
                  {item.icon}
                  <span>{item.label}</span>
                </Link>
              ))}

              <button
                onClick={() => {
                  logout();
                  setIsMobileMenuOpen(false);
                }}
                className="flex items-center space-x-3 w-full px-4 py-3 rounded-lg bg-red-600 hover:bg-red-700 transition-all"
              >
                <LogOut className="w-5 h-5" />
                <span>Logout</span>
              </button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
